import { createStyles, makeStyles, Theme } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import './App.css'
import DropDown, { MunicipalityData } from './components/DropDown'
import GeoButton from './components/GeoButton'
import placeholder from './data/kommundataPlaceholder'
import kommunkoder from './data/kommunkod'
import { get } from 'lodash'

const h1Font = 'clamp(2.5rem, 8vmin, 5rem)'
const h2Font = 'clamp(1.8rem, 5vmin, 3rem)'
const h3Font = 'clamp(1.5rem, 4vmin, 2rem)'
const h4Font = 'clamp(1.2rem, 3vmin, 1.5rem)'
const pFont = 'clamp(0.75rem, 2vmin, 1rem)'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            fontSize: pFont,
            backgroundColor: 'white', //'#f6f6f6',
        },

        mainContainer: {
            textAlign: 'center',
            margin: 'auto',
        },

        medLogo: {
            width: '30vmin',
            margin: '1rem',
        },
        logoSubTitle: {
            fontSize: h3Font,
        },
        title: {
            fontSize: h1Font,
            fontWeight: 'bold',
        },
        subTitle: {
            fontSize: h2Font,
        },

        chartText: {
            fontSize: h3Font,
            margin: '2vmin',
            marginBottom: '0',
            justifyItems: 'center',
        },
        chartTitle: {
            fontWeight: 'bold',
        },
        chartSubTitle: {
            fontSize: h4Font,
        },

        warning: {
            '& div.MuiAlert-message': {
                flexGrow: '1',
            },
        },
        copyIcon: {
            margin: '1vmin',
            '&:hover': {
                cursor: 'pointer',
            },
        },
        geoButton: {
            margin: '1vmin',
            marginBlock: '0',
            '& span.MuiButton-label': {
                fontSize: pFont,
            },
        },
        dropdown: {
            display: 'flex',
            alignContent: 'center',
            '& div.MuiAutocomplete-root': {
                flexGrow: '1',
            },
        },

        mainInfoContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
        },

        infoContainer: {
            display: 'flex',
            flexWrap: 'wrap',

            textAlign: 'center',
            width: '50%',
            '& ul': {
                display: 'inline-block',
                textAlign: 'left',
                '& li': {
                    marginTop: '0.5rem',
                    fontSize: pFont,
                },
            },
        },
        barChart: {
            display: 'flex',
            margin: '2vmin',
            marginTop: '0',
            justifyContent: 'center',
        },

        mainSwishContainer: {
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '2rem',
        },
        swishContainer: {
            display: 'flex',
            flexWrap: 'wrap',

            textAlign: 'center',
            width: '50%', // 70%
            '& ul': {
                display: 'inline-block',
                textAlign: 'left',
                '& li': {
                    marginTop: '0.5rem',
                    fontSize: pFont,
                },
            },
        },
        medSwishLogo: {
            margin: '2vmin',
            width: '230px',
            justifyItems: 'center',
        },
        swishTitle: {
            fontSize: h3Font,
        },
        swishText: {
            fontSize: pFont,
        },
        detailsContainer: {
            display: 'inline-block',
            maxWidth: '70%',
            fontSize: '12px',
            textAlign: 'left',
        },
    })
)

function App() {
    const classes = useStyles()
    const [activeMunicipality, setActiveMunicipality] =
        useState<MunicipalityData>(placeholder)
    const [medVotes, setMedVotes] = useState<number>(5)
    const [showDetails, setShowDetails] = useState<boolean>(false)
    const [mandateSimulationUrl, setMandateSimulationUrl] = useState('')

    const smallPartyThreshold =
        Number(activeMunicipality.votingareas) > 1 ? 0.03 : 0.02
    const targetCount = Math.round(
        Number(activeMunicipality.voters) * smallPartyThreshold
    )

    useEffect(() => {
        let municipalityCode = get(
            kommunkoder,
            activeMunicipality.municipality,
            ''
        ) as string

        // https://data.val.se/valsimulator/?l=rkl2018K0560&p.99.n=MED&p.99.ok=1&v.0.r.99=77
        //data.val.se/valsimulator/?l=rkl2018K0483&p.99.n=MED&p.99.ok=1&v.0.r.99=460
        const municipalityValue = 'rkl2018K' + municipalityCode //0560
        const baseUrl = 'https://data.val.se/valsimulator/'
        const url = new URL('', baseUrl)
        url.searchParams.set('l', municipalityValue)
        url.searchParams.set('p.99.n', 'MED')
        url.searchParams.set('p.99.ok', '1')
        url.searchParams.set(
            'v.0.r.99',
            Math.round(
                Number(activeMunicipality.voters) * smallPartyThreshold
            ) + ''
        )
        setMandateSimulationUrl(url.toString() + '#slutlig')

        console.log('url:', url.toString() + '#slutlig')
    }, [activeMunicipality, smallPartyThreshold])

    return (
        <>
            <div className={classes.root}>
                <div className={classes.mainContainer}>
                    {/* <div className={classes.warning}>
                        <Alert severity="warning">
                            <AlertTitle>
                                OBS! Detta är en testapplikation!
                            </AlertTitle>
                            Data som indikerar avsiktsförklarade röster är{' '}
                            <strong>slumpvis genererade!</strong>
                            <div>
                                Har du synpunkter, frågor eller vill rapportera
                                ett fel, maila till{` `}
                                <span
                                    className={classes.copyIcon}
                                    onClick={() =>
                                        navigator.clipboard.writeText(
                                            'emanuel.lindstrom@medborgerligsamling.se'
                                        )
                                    }
                                >
                                    <Tooltip
                                        title="Kopiera: emanuel.lindstrom@medborgerligsamling.se"
                                        placement="right"
                                    >
                                        <FileCopyIcon
                                            style={{ width: '4vmin' }}
                                        />
                                    </Tooltip>
                                </span>
                            </div>
                        </Alert>
                    </div> */}
                    <img
                        className={classes.medLogo}
                        src={'/MS_logo_trans_510x510.png'}
                        alt={'med-logo'}
                    />
                    <div className={classes.logoSubTitle}>
                        Antal röster för att MED ska få mandat i din kommun 2022
                    </div>

                    {activeMunicipality !== placeholder && (
                        <>
                            <div className={classes.title}>
                                {activeMunicipality.municipality}
                            </div>
                            {activeMunicipality && (
                                <div className={classes.subTitle}>
                                    {targetCount} röster ger MED minst ett
                                    mandat
                                </div>
                            )}
                            <div className={classes.subTitle}>
                                {`${
                                    activeMunicipality
                                        ? 'i kommunfullmäktige 2022!'
                                        : 'MED till kommunfullmäktige!'
                                }`}
                            </div>
                        </>
                    )}

                    {activeMunicipality !== placeholder && (
                        <>
                            <ul>
                                <li>{`${activeMunicipality.municipality} har ca ${activeMunicipality.registeredVoters} röstberättigade invånare.`}</li>
                                <li>{`Totalt antal röster år 2022 estimeras till ${activeMunicipality.voters} st`}</li>
                                <li>{`Valdeltagandet för kommunvalet år 2018 var ${activeMunicipality.participation}%`}</li>
                                <li>{`Kommunen har ${
                                    Number(activeMunicipality.votingareas) > 1
                                        ? activeMunicipality.votingareas +
                                          ' valkretsar'
                                        : '1 valkrets'
                                } och en småpartispärr på ${
                                    smallPartyThreshold * 100
                                }%`}</li>
                                <li>
                                    {`För att komma över ${Math.round(
                                        smallPartyThreshold * 100
                                    )}%-spärren krävs ca ${Math.round(
                                        Number(activeMunicipality.voters) *
                                            smallPartyThreshold
                                    )} röster.`}
                                </li>
                                <li>
                                    Hur många mandat skulle {targetCount} röster
                                    i {activeMunicipality.municipality} ge år
                                    2022?
                                    <br /> Se den färdiga uträkningen på{' '}
                                    <i>data.val.se/valsimulator</i>{' '}
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={mandateSimulationUrl}
                                    >
                                        Klicka här!
                                    </a>
                                </li>
                            </ul>
                        </>
                    )}

                    <div className={classes.dropdown}>
                        <DropDown
                            activeMunicipality={activeMunicipality}
                            setActiveMunicipality={setActiveMunicipality}
                            medVotes={medVotes}
                            setMedVotes={setMedVotes}
                        />
                    </div>
                    <div className={classes.geoButton}>
                        <GeoButton
                            activeMunicipality={activeMunicipality}
                            setActiveMunicipality={setActiveMunicipality}
                        />
                    </div>

                    {activeMunicipality !== placeholder && (
                        <>
                            <br />
                            <hr />
                            <br />
                            <div className={classes.mainSwishContainer}>
                                {/* <div className={classes.swishContainer}>
                                    <div className={classes.swishText}>
                                        <div className={classes.swishTitle}>
                                            Bidra till förändring!
                                        </div>
                                        <div>
                                            <ul>
                                                <li>
                                                    Skicka valfri summa till
                                                    Medborgerlig Samlings swish.
                                                    och märk donationen med{' '}
                                                    <b>
                                                        {
                                                            activeMunicipality.municipality
                                                        }
                                                    </b>
                                                </li>
                                                <li>
                                                    Eller bli medlem genom att
                                                    skicka 250kr och märk
                                                    betalningen med din{' '}
                                                    <b>
                                                        e-post, kommun (ej
                                                        postadress!)
                                                    </b>{' '}
                                                    och <b>postnummer</b>.
                                                </li>
                                            </ul>
                                            <br />
                                            <b>Swish: 1234029088</b>
                                        </div>
                                    </div>
                                </div> */}
                                <h2>
                                    Förändra Sverige! Donera valfri summa till
                                    MED!
                                </h2>
                                <b>Swish: 1234029088</b>
                                <img
                                    className={classes.medSwishLogo}
                                    src={'/swish-265x300.png'}
                                    alt={'med-swish-QR'}
                                />
                                <span>
                                    <h3>
                                        Eller{' '}
                                        <a href="https://www.medborgerligsamling.se/bli-medlem/">
                                            Bli medlem!
                                        </a>
                                    </h3>
                                </span>
                                <br />
                                <br />
                                <div className={classes.detailsContainer}>
                                    <div
                                        style={{ cursor: 'pointer' }}
                                        onClick={() =>
                                            setShowDetails(!showDetails)
                                        }
                                    >
                                        Hur har vi räknat?
                                    </div>

                                    {showDetails && (
                                        <>
                                            <div>
                                                Datan är från val.se. Rapporten
                                                över antal röstberättigade är
                                                från mars 2022 och
                                                valdeltagandet är från förra
                                                kommunvalet år 2018.
                                            </div>
                                            <div>
                                                Läs mer om hur småparispärren
                                                och mandatfördelningen fungerar
                                                på{' '}
                                                <a href="https://www.val.se/val-och-folkomrostningar/det-svenska-valsystemet/rostrakning-och-valresultat/mandatfordelning.html">
                                                    val.se
                                                </a>
                                            </div>
                                            <div>
                                                Antal röster som krävs för att
                                                få mandat är ett estimat på hur
                                                många mandat som behövs för att
                                                komma över småpartispärren som
                                                är på antingen 2 eller 3%.
                                                Oftast innebär detta mer än 1
                                                mandat, men det är icke-trivialt
                                                att beräkna. Se{' '}
                                                <a href="https://www.val.se/val-och-folkomrostningar/det-svenska-valsystemet/rostrakning-och-valresultat/rakna-sjalv.html">
                                                    val.se räkna själv
                                                </a>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

export default App
